import {
  // issueComment fetch type:
  ISSUE_COMMENT_FETCH_PROCESSING,
  ISSUE_COMMENT_FETCH_SUCCESS,
  ISSUE_COMMENT_FETCH_FAILED,
  ISSUE_COMMENT_FETCH_CLEAR,

  // issue update type:
  ISSUE_COMMENT_UPDATE_SUCCESS,
  ISSUE_COMMENT_UPDATE_FAILED,
} from '../constants';
import { issueComment } from '../data';

/* ===============================================
 *    Fetch issueComment
 * =============================================== */

// setStateIssueCommentFetchToProcessing()
const setStateIssueCommentFetchToProcessing = () => ({
  type: ISSUE_COMMENT_FETCH_PROCESSING,
});

/**
 * setStateIssueCommentFetchToSuccess()
 * @param {*} payload
 */
const setStateIssueCommentFetchToSuccess = (payload) => ({
  type: ISSUE_COMMENT_FETCH_SUCCESS,
  payload,
});

/**
 * setStateIssueCommentFetchToFailed()
 * @param {} payload
 */
const setStateIssueCommentFetchToFailed = (payload) => ({
  type: ISSUE_COMMENT_FETCH_FAILED,
});

/**
 * setStateIssueCommentFetchToClear()
 */
const setStateIssueCommentFetchToClear = () => ({
  type: ISSUE_COMMENT_FETCH_CLEAR,
});

/**
 * getIssueComment()
 * @param {object} params
 * @param {object} params.package base64 of props {lang, issue_id, orderByAcs = true }
 * @returns
 */
export const getIssueComment = (params) => {
  return async (dispatch, getState) => {
    dispatch(setStateIssueCommentFetchToProcessing());
    try {
      // issueComment (getList)
      let comments = await issueComment.getList(params, {
        includedThumbnail: false,
      });

      dispatch(
        setStateIssueCommentFetchToSuccess(comments)
      );
    } catch (error) {
      dispatch(setStateIssueCommentFetchToFailed());
      throw error;
    }
  };
};

/* ===============================================
 *  Add/Update issueComment consist of
 *  - add issueComment data
 * =============================================== */
const setStateIssueCommentUpdateToSuccess = (payload) => ({
  type: ISSUE_COMMENT_UPDATE_SUCCESS,
  payload: payload,
});

const setStateIssueCommentUpdateToFailed = () => ({
  type: ISSUE_COMMENT_UPDATE_FAILED,
});

/**
 *  addIssueComment()
 * @param {object} props,
 * @param {object} props.issue_id issue-id
 * @param {object} props.data comment data object
 * @param {object} params.params, params: {package} base64 of props {lang, issue_id, orderByAcs = true }
 * @return
 */
export const addIssueComment = ({ issue_id, data, params }) => {
  return async (dispatch, getState) => {
    try {
      // 1 Post insert IssueComment
      await issueComment.addIssueComment({
        issue_id,
        comment: data,
        logMode: 'issueCommentCreate',
      });

      // 2 Get comment updated 
      let comments = await issueComment.getList(params, {
        includedThumbnail: false,
      });

      dispatch(
        setStateIssueCommentUpdateToSuccess(comments)
      );
    } catch (error) {
      dispatch(setStateIssueCommentUpdateToFailed());
      throw error;
    }
  };
};

/**
 *  updateIssueComment()
 * @param {object} data , comment data type obect
 * @returns
 */
export const updateIssueComment = ({ issue_id, data, params }) => {
  return async (dispatch, getState) => {
    try {
      // 1 Put update IssueComment
      await issueComment.updateIssueComment({
        issue_id,
        comment: data,
        logMode: 'issueCommentEdit',
      });

      // 2 Get comments updated 
      let comments = await issueComment.getList(params, {
        includedThumbnail: false,
      });
      // 3 Then setStateIssueCommentUpdateToSuccess by comments
      dispatch(
        setStateIssueCommentUpdateToSuccess(comments)
      );
    } catch (error) {
      dispatch(setStateIssueCommentUpdateToFailed());
      throw error;
    }
  };
};
